//Theme styles
import '../global/global.scss';

import './utilities.js';

//Components
import '../components/components.js';

//Libraries
import  '../../node_modules/svg-injector/dist/svg-injector.min.js';
import  '../../node_modules/slick-carousel/slick/slick.min.js';
import  '../../node_modules/popper.js/dist/popper.min.js';
import {Modal, Collapse} from '../../node_modules/bootstrap/dist/js/bootstrap.js';
import  '../../node_modules/jquery/dist/jquery.js';
import  '../../node_modules/jquery-validation/dist/jquery.validate.js';

//Passing bootstrap object context to window for other script (John - 2023/03)
window.modal = Modal;
window.collapse = Collapse;
